"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryList = void 0;
const tslib_1 = require("tslib");
const country_list_1 = tslib_1.__importDefault(require("country-list"));
function getCountryList(hoistCountryCodeList = []) {
    const sortFn = (a, b) => {
        const aIndex = hoistCountryCodeList.indexOf(a.code);
        const bIndex = hoistCountryCodeList.indexOf(b.code);
        if (aIndex < 0 && bIndex < 0)
            return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
        if (aIndex > -1 && bIndex > -1)
            return aIndex < bIndex ? -1 : 1;
        return aIndex > -1 ? -1 : 1;
    };
    return country_list_1.default.getData().sort(sortFn);
}
exports.getCountryList = getCountryList;
//# sourceMappingURL=countryList.js.map